module.exports = __webpack_public_path__ + "d81059423d6a112568ad192c1e94b27c.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/PrintTypes/embroidery.jpg
// module id = 864
// module chunks = 1